import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { Card, Text, Heading, Stack, Inline, Box } from 'braid-design-system';
import { vars } from 'braid-design-system/css';
import React from 'react';

import CustomSvg from 'src/components/CustomSvg/CustomSvg';
import { getConfigValues } from 'src/config';
import type { ListingProduct } from 'src/generated/graphql';
import AmericanExpressSvg from 'src/images/amex.svg';
import MasterCardSvg from 'src/images/mastercard.svg';
import VisaSvg from 'src/images/visa.svg';
import type { ProductBundle } from 'src/types/productBundle';

import CheckoutForm from './components/CheckoutForm/CheckoutForm';

interface PaymentDetailsProps {
  isListingLus: boolean;
  isBundleProduct: boolean;
  client: { id: string };
  productBundle: ProductBundle;
  selectedProducts: ListingProduct[];
  searchBoostChecked: boolean;
  onSearchBoostToggle: () => void;
}

const PaymentDetails = ({
  isListingLus,
  isBundleProduct,
  client,
  productBundle,
  selectedProducts,
  searchBoostChecked,
  onSearchBoostToggle,
}: PaymentDetailsProps) => (
  <Card>
    <Stack space="medium">
      <Heading level="3">Payment details</Heading>
      <Stack space="xxsmall">
        <Text>We accept:</Text>
        <Box style={{ minHeight: 45, marginTop: vars.space.xsmall }}>
          <Inline space="xsmall">
            <CustomSvg svg={VisaSvg} width={50} />
            <CustomSvg svg={AmericanExpressSvg} width={50} />
            <CustomSvg svg={MasterCardSvg} width={50} />
          </Inline>
        </Box>
      </Stack>

      {typeof window !== 'undefined' && (
        <Elements stripe={loadStripe(getConfigValues().STRIPE_API_KEY)}>
          <CheckoutForm
            isListingLus={isListingLus}
            isBundleProduct={isBundleProduct}
            client={client}
            productBundle={productBundle}
            selectedProducts={selectedProducts}
            searchBoostChecked={searchBoostChecked}
            onSearchBoostToggle={onSearchBoostToggle}
          />
        </Elements>
      )}
    </Stack>
  </Card>
);

export default PaymentDetails;
